module.exports = {
  landing: {
    section1: {
      title: "Soon something completely new",
      txt2: "Increase productivity, standardize processes, disallow control and transfer with security, simplicity and speed"
    },
  },
};
